import React, { useEffect, useRef, useState } from "react";
import Message from "./Message";
import Rosheta from "./Rosheta";
import { Row, Col, Button } from "react-bootstrap";
import VisitMedicationForm from "./VisitMedicationForm";
import { FaEdit, FaPlusCircle, FaPrint } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { notify } from "./notify";
import axios from "axios";
import { logout } from "../actions/userActions";
import Skeleton from "react-loading-skeleton";
import VisitRoshetaPrint from "./VisitRoshetaPrint";
import ReactToPrint from "react-to-print";
import { AiOutlineSend } from "react-icons/ai";
import { listTradeLabels } from "../actions/drugActions";

const VisitRosheta = ({ visit }) => {
  const [editRosheta, setEditRosheta] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [newTrades, setNewTrades] = useState([]);

  let [rosheta, setRosheta] = useState(
    visit?.physicianSection?.rosheta?.length > 0
      ? visit.physicianSection.rosheta
      : [
          {
            idx: Math.random(),
            tradeLabel: "",
            tradeId: "",
            tradeRootId: "",
            direction: "",
          },
        ],
  );
  const dispatch = useDispatch();

  const tradeLabelsStore = useSelector((state) => state.tradeLabelsStore);
  const { noRequest } = tradeLabelsStore;

  if (!localStorage.tradeLabels && noRequest) {
    dispatch(listTradeLabels());
  }

  let tradeLabels =
    localStorage.tradeLabels && JSON.parse(localStorage.tradeLabels);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const addMedication = () => {
    setRosheta([
      ...rosheta,
      {
        idx: Math.random(),
        tradeLabel: "",
        tradeId: "",
        tradeRootId: "",
        direction: "",
      },
    ]);
  };
  const deleteMedication = (medication) => {
    // console.log(medication);
    if (window.confirm("You will delete this medication. Are you sure?")) {
      if (medication.idx) {
        setRosheta(rosheta.filter((p) => p.idx !== medication.idx));
      } else {
        setRosheta(rosheta.filter((p) => p._id !== medication._id));
      }
    }
  };

  const componentRef = useRef();

  const updateRosheta = async () => {
    try {
      setLoading(true);

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `/api/visits/${visit._id}/updateVisitRosheta`,
        { rosheta: rosheta.filter((r) => r.tradeId) },
        config,
      );
      setRosheta(data.updatedRosheta);
      setNewTrades(data.addedTrades);
      setLoading(false);
      setEditRosheta(false);
      notify({
        title: "Rosheta Update",
        message: <p className="lead">Data updated successfully.</p>,
        type: "success",
        duration: 4000,
      });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      setError(message);
      setLoading(false);
    }
  };
  useEffect(() => {
    const trueNewTrades = newTrades.filter((t) => t._id && t.label);
    // console.log("trueNewTrades:", newTrades);

    if (trueNewTrades.length > 0) {
      // merge new trades if found to localStorage tradeLabels
      const clientTradeLabels =
        JSON.parse(localStorage.getItem("tradeLabels")) || [];
      clientTradeLabels.push(...trueNewTrades);
      localStorage.setItem("tradeLabels", JSON.stringify(clientTradeLabels));
      // SOMETHING LIKE REFERESH

      //then clear state
      setNewTrades([]);
    }
  }, [newTrades]);

  return (
    <>
      {/* <pre>{JSON.stringify(rosheta, null, 2)}</pre> */}
      <div style={{ display: "none" }}>
        <VisitRoshetaPrint
          ref={componentRef}
          rosheta={visit.physicianSection.rosheta}
        />
      </div>
      {loading ? (
        <>
          {" "}
          <Skeleton height="120px" className="mb-5" />
        </>
      ) : editRosheta ? (
        <>
          {" "}
          <div className="py-2">
            {rosheta.map((m) => (
              <VisitMedicationForm
                key={m._id || m.idx}
                tradeLabels={tradeLabels}
                medication={m}
                deleteMedication={deleteMedication}
                rosheta={rosheta}
              />
            ))}

            <Row className="justify-content-center">
              <Col className="text-center">
                <Button
                  className="btn btn-secondary btn-block my-3"
                  onClick={() => addMedication()}
                >
                  <FaPlusCircle className="me-2" /> Click to Add Another
                  Medication
                </Button>
              </Col>{" "}
            </Row>
            {error && (
              <Message
                children={error}
                variant={`danger`}
                setMessage={setError}
              />
            )}

            <Row className="w-100 justify-content-end my-2">
              <Col className="mr-2 col-auto">
                <Button
                  variant="outline-success"
                  onClick={() => updateRosheta()}
                >
                  <AiOutlineSend />
                  Update Visit Medications
                </Button>
              </Col>
            </Row>
          </div>
        </>
      ) : (
        <div>
          {rosheta && rosheta.length > 0 ? (
            <>
              <Rosheta
                rosheta={rosheta}
                physician={userInfo?._id}
                tradeLabels={tradeLabels}
              />
            </>
          ) : (
            <Message children={`No prescription yet`} variant={`info`} />
          )}
          <div className="d-flex justify-content-between width-100">
            <div>
              <ReactToPrint
                trigger={() => (
                  <Button>
                    <FaPrint /> Print Rx
                  </Button>
                )}
                content={() => componentRef.current}
                documentTitle={``}
              />
            </div>
            <div className="mr-2">
              <Button
                variant="outline-primary"
                onClick={() => setEditRosheta(true)}
              >
                <FaEdit /> Edit Medications
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VisitRosheta;
